// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-picker-panel__shortcut{margin-bottom:0;height:28px;line-height:28px}", ""]);
// Exports
module.exports = exports;
